import { WHOLESALE_RANGE, RETAIL_RANGE } from "@/constants/aiTiersCatalog";

export const INTERCEPTOR_HEADLINE = {
  title: "The Interceptor AI Employee",
  subtitle: "9-Second Intercept vs. Next-Morning Leakage",
  lead:
    "Stop burning off-hours traffic. While your client's competitors sleep, an autonomous digital employee captures, vets, and books every inbound lead natively inside the CRM in under 9 seconds.",
};

export const INTERCEPTOR_NARRATIVE = [
  {
    label: "The Problem",
    text: "Up to 40% of high-intent leads arrive during dark hours and burn until 9:00 AM.",
  },
  {
    label: "The AI Employee in Action",
    text: "Immediate qualification, geocoding validation, and direct calendar synchronization.",
  },
  {
    label: "The Result",
    text: "Closed deals waiting in the pipeline before your client's team even wakes up.",
  },
];

export const PIPELINE_STAGES = [
  { id: "inbound", code: "SIG-01", label: "Inbound Signal", ping: false },
  { id: "intercept", code: "INT-02", label: "Intercept", ping: true },
  { id: "qualify", code: "VET-03", label: "Qualify", ping: false },
  { id: "book", code: "BK-04", label: "Book", ping: false },
  { id: "crm", code: "LOG-05", label: "CRM Lock", ping: false },
];

export const INFRASTRUCTURE_FEATURES = [
  {
    stage: "intercept",
    code: "INT-02",
    title: "9-Second Instant Capture (24/7)",
    tagline: "Lock the lead before competitors open their inbox.",
    description:
      "When your marketing campaigns drive a high-intent lead at 2 AM on a Sunday, the system intercepts the inquiry in under 9 seconds. While competitors rely on slow, manual callbacks the next morning, FractoLabs locks the lead down instantly.",
  },
  {
    stage: "qualify",
    code: "VET-03",
    title: "Zero-Hallucination Qualification",
    tagline: "Policy Engine vets every answer. Zero fiction.",
    description:
      "Powered by our strict Policy Engine, the AI vets the prospect like a human operator. It never hallucinates, safeguarding your client's brand and reputation.",
  },
  {
    stage: "book",
    code: "BK-04",
    title: "Direct Calendar Conversion",
    tagline: "Live slots in chat, not a Calendly link.",
    description:
      "It doesn't just \"chat.\" The AI Employee extracts real-time slots directly from the team's calendar, secures a booked appointment on the spot, and logs all data directly into the CRM.",
  },
  {
    stage: "crm",
    code: "LOG-05",
    title: "Plugs Lead Leakage",
    tagline: "Off-hours gaps closed so ad spend looks 2× efficient.",
    description:
      "Up to 40% of inbound leads are burned during off-hours and weekends. This infrastructure permanently patches that operational hole, making your agency's ad spend look 2x more efficient.",
  },
];

export const REVENUE_LOOP_THESIS =
  "You don't refer clients for affiliate fees. You own the infrastructure and keep 100% of the margin spread.";

export const REVENUE_EQUATION = {
  retail: { label: "Client Pays (Retail)", range: RETAIL_RANGE, sub: "/ mo per AI Employee" },
  wholesale: { label: "Your Cost (Wholesale)", range: WHOLESALE_RANGE, sub: "flat infrastructure" },
  spread: { label: "You Keep", range: "$140–$400+", sub: "pure margin / client / mo" },
};

export const REVENUE_LOOP_STEPS = [
  {
    step: "1",
    rung: "BUNDLE",
    title: "Package Your Retainer",
    tagline: "Bolt the 24/7 module into Ads, Social, or SEO.",
    description:
      "You bundle the \"24/7 After-Hours Booking\" module directly into your existing Google Ads, Paid Social, or SEO packages.",
  },
  {
    step: "2",
    rung: "PRICE",
    title: "Set Your Retail Price",
    tagline: "Client sees booked meetings and gladly pays retail.",
    description:
      `You charge your client the full retail price (${RETAIL_RANGE}/month). They gladly pay because they see a calendar filled with qualified meetings. Meanwhile, your wholesale cost is a flat ${WHOLESALE_RANGE}/month depending on tier.`,
  },
  {
    step: "3",
    rung: "KEEP",
    title: "Keep 100% of the Spread",
    tagline: "Zero headcount. Pure recurring profit.",
    description:
      "You retain $140 to $400+ of pure monthly margin from every single client, scaling your agency's MRR without adding a single headcount.",
  },
];
